module.exports = __webpack_public_path__ + "img/kid.3a8b7f6b.png";